<template>
  <Modal
    v-model="_value"
    width="400"
    title="第三方监控合约追加备注"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <Form ref="renewalOrderForm" :model="renewalOrder">
      <FormItem prop="content">
        <Col span="6">
          <label>备注</label>
        </Col>
        <Col span="18">
          <Input style="width: 100%;" v-model="renewalOrder.content"
                 type="textarea"
                 placeholder="请输入备注"></Input>
        </Col>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'monitoringserviceaddtoremarkmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      renewalOrder: {
        id: null,
        content: null
      }
    }
  },
  methods: {
    ...mapActions([
      'MonitoringServiceServ_AddToRemark'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认追加备注</p>',
        onOk: () => {
          store.dispatch('MonitoringServiceServ_AddToRemark',
            { params: this.renewalOrder }).then(() => {
            this.$Message.success('确认成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.renewalOrder.id = this._initValue
        this.renewalOrder.content = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
